export default "__VITE_ASSET__D9I2saJu__"